









import Vue from 'vue'
import Component from 'vue-class-component'
import LineChartWidget from '@/components/widgets/LineChartWidget.vue'
import {LoginAuditChartSection} from '@/models/LobbyDataResponse.model'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {Getter} from 'vuex-class'

@Component({
    components: {
        LineChartWidget
    }
})
export default class LoginAuditChartSectionComponent extends Vue {

    @Getter('loginAuditChartSection', StoreNamespace.LOBBY) loginAuditChartSection!: LoginAuditChartSection

    dataExists(): boolean {
        return this.loginAuditChartSection.datasets && !(this.loginAuditChartSection.datasets.length < 1)
    }
}
